var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardWidgetAnalisiReddituale',{staticClass:"widget-analisi-reddituale-consuntiva",attrs:{"title":"Analisi Reddituale Consuntiva","values":_vm.values}})}
var staticRenderFns = []

export { render, staticRenderFns }